import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";
import { lkred, lkgreen } from "../../Dashboard/styles";
import { connect } from "react-redux";
import { faultBar } from "../../Utility/dataSet";

class barchart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateRange: props.dateRange,
      location: props.location,
      series: [],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: "20px",
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: 15,
          style: {
            fontSize: "9px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 0.5,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        colors: [lkred, lkgreen],
        grid: {
          borderColor: "#f1f1f1",
        },
        xaxis: {
          categories: [
            "Power-failure",
            "ESB-pressed",
            "Meter-failure",
            "PowerBoard-failure",
            "Earth-leakage",
            "Over-temperature",
            "Over-voltage",
            "Under-voltage",
            "No-load",
            "Over-current",
          ],
        },
      },
    };
  }

  filterSeriesOnDate = () => {
    const currentDateRange = this.props.dateRange;
    const startDate = new Date(currentDateRange[0]);
    const endDate = new Date(currentDateRange[1]);
    const filteredData = faultBar(startDate, endDate);
    // Update state with filtered series
    this.setState({ series: filteredData });
  };

  componentDidMount() {
    this.filterSeriesOnDate();
  }

  componentDidUpdate(prevProps) {
    const prevDateRange = prevProps.dateRange;
    const currentDateRange = this.props.dateRange;

    // Convert the date strings to Date objects
    const prevYear1 = new Date(prevDateRange[0]);
    const prevYear2 = new Date(prevDateRange[1]);
    const currentYear1 = new Date(currentDateRange[0]);
    const currentYear2 = new Date(currentDateRange[1]);

    // Check if the date range or location has changed by comparing timestamps
    if (prevYear1.getTime() !== currentYear1.getTime() || prevYear2.getTime() !== currentYear2.getTime() || prevProps.location !== this.props.location) {
      // Update state with the new date range and location
      this.setState({
        dateRange: currentDateRange,
        location: this.props.location,
      });

      // Apply filters based on the new date range
      this.filterSeriesOnDate();
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.series && this.state.series?.length > 0 && <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height="351" />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  dateRange: state.dashboardFilter.dateRange,
  location: state.dashboardFilter.location,
});

export default connect(mapStateToProps)(barchart);
